import { render, staticRenderFns } from "./chapters-table.vue?vue&type=template&id=1fb29900&scoped=true"
import script from "./chapters-table.vue?vue&type=script&lang=js"
export * from "./chapters-table.vue?vue&type=script&lang=js"
import style0 from "./chapters-table.vue?vue&type=style&index=0&id=1fb29900&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fb29900",
  null
  
)

export default component.exports